import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { LoginAttempt, ClientUser } from '../../models/client-user.model';
import { Client } from '../../models/client-management.model';

@Component({
  selector: 'app-login-logs',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './login-logs.component.html',
  styleUrls: ['./login-logs.component.scss']
})
export class LoginLogsComponent implements OnInit {
  loginAttempts: LoginAttempt[] = [];
  loading = false;
  error: string | null = null;

  // Pagination
  currentPage = 1;
  pageSize = 20;
  totalCount = 0;
  totalPages = 0;

  // Filters
  clients: Client[] = [];
  users: ClientUser[] = [];
  selectedClientId: number | null = null;
  selectedUserId: number | null = null;
  selectedStatus: string = '';

  statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'Success', label: 'Success' },
    { value: 'AwaitingOTP', label: 'Awaiting OTP' },
    { value: 'WrongPassword', label: 'Wrong Password' },
    { value: 'WrongOTP', label: 'Wrong OTP' }
  ];

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loadClients();
    this.loadLoginAttempts();
  }

  loadClients(): void {
    this.apiService.getClients().subscribe({
      next: (data) => this.clients = data,
      error: (err) => console.error('Error loading clients:', err)
    });
  }

  loadUsersForClient(): void {
    if (this.selectedClientId) {
      this.apiService.getClientUsersByClient(this.selectedClientId).subscribe({
        next: (data) => this.users = data,
        error: (err) => console.error('Error loading users:', err)
      });
    } else {
      this.users = [];
      this.selectedUserId = null;
    }
  }

  loadLoginAttempts(): void {
    this.loading = true;
    this.error = null;

    this.apiService.getAllLoginAttempts(
      this.currentPage,
      this.pageSize,
      this.selectedClientId || undefined,
      this.selectedUserId || undefined,
      this.selectedStatus || undefined
    ).subscribe({
      next: (response) => {
        this.loginAttempts = response.data;
        this.totalCount = response.totalCount;
        this.totalPages = response.totalPages;
        this.loading = false;
      },
      error: (err) => {
        this.error = 'Failed to load login attempts';
        this.loading = false;
        console.error('Error loading login attempts:', err);
      }
    });
  }

  onClientChange(): void {
    this.selectedUserId = null;
    this.loadUsersForClient();
    this.currentPage = 1;
    this.loadLoginAttempts();
  }

  onUserChange(): void {
    this.currentPage = 1;
    this.loadLoginAttempts();
  }

  onStatusChange(): void {
    this.currentPage = 1;
    this.loadLoginAttempts();
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.loadLoginAttempts();
    }
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Success': return 'status-success';
      case 'AwaitingOTP': return 'status-awaiting';
      case 'WrongPassword': return 'status-wrong-password';
      case 'WrongOTP': return 'status-wrong-otp';
      default: return '';
    }
  }

  getStatusLabel(status: string): string {
    switch (status) {
      case 'Success': return 'Success';
      case 'AwaitingOTP': return 'Awaiting OTP';
      case 'WrongPassword': return 'Wrong Password';
      case 'WrongOTP': return 'Wrong OTP';
      default: return status;
    }
  }

  getPageNumbers(): number[] {
    const pages: number[] = [];
    const start = Math.max(1, this.currentPage - 2);
    const end = Math.min(this.totalPages, this.currentPage + 2);
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }
}

